export type ListenerType<T> = [T] extends [(...args: infer U) => any]
  ? U
  : [T] extends [void]
    ? []
    : [T]

export class EventEmitter<TEventRecord> {
  private listeners: {
    [key: string]: Array<(...args: any) => void>
  } = {}
  private listenersOnce: {
    [key: string]: Array<(...args: any) => void>
  } = {}

  on<P extends keyof TEventRecord>(
    event: P,
    listener: (...args: ListenerType<TEventRecord[P]>) => void,
  ) {
    this.listeners[event as string] = this.listeners[event as string] || []
    this.listeners[event as string].push(listener)
    return this
  }

  once<P extends keyof TEventRecord>(
    event: P,
    listener: (...args: ListenerType<TEventRecord[P]>) => void,
  ) {
    this.listenersOnce[event as string] =
      this.listenersOnce[event as string] || []
    this.listenersOnce[event as string].push(listener)
    return this
  }

  protected emit<P extends keyof TEventRecord>(
    event: P,
    ...args: ListenerType<TEventRecord[P]>
  ) {
    this.listeners[event as string]?.forEach((listener) => listener(...args))
    this.listenersOnce[event as string]?.forEach((listener) =>
      listener(...args),
    )
    this.listenersOnce[event as string] = []
  }

  off<P extends keyof TEventRecord>(
    event: P,
    listener: (...args: any[]) => any,
  ) {
    this.listeners[event as string] = this.listeners[event as string] || []
    this.listeners[event as string] = this.listeners[event as string].filter(
      (fn) => fn !== listener,
    )
    return this
  }

  removeAllListeners() {
    for (const event in this.listeners) {
      delete this.listeners[event]
    }
    this.listeners = {}
  }
}
